"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UpdateRunWayProcessing {
    constructor(sourceId, targetId, percent, reason) {
        this.sourceId = sourceId;
        this.targetId = targetId;
        this.percent = percent;
        this.reason = reason;
    }
}
exports.UpdateRunWayProcessing = UpdateRunWayProcessing;
function updateRunWayProcessor(battle, data, _) {
    // if (!(data instanceof UpdateRunWayProcessing)) return 0;
    return battle.runway.updatePercent(data.targetId, data.percent) ? -1 : 0;
}
exports.default = updateRunWayProcessor;
